import { render, staticRenderFns } from "./quem_e_quem_informes.vue?vue&type=template&id=7cec595f&scoped=true&"
import script from "./quem_e_quem_informes.vue?vue&type=script&lang=js&"
export * from "./quem_e_quem_informes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec595f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cec595f')) {
      api.createRecord('7cec595f', component.options)
    } else {
      api.reload('7cec595f', component.options)
    }
    module.hot.accept("./quem_e_quem_informes.vue?vue&type=template&id=7cec595f&scoped=true&", function () {
      api.rerender('7cec595f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/home/quem_e_quem_informes.vue"
export default component.exports